import React from 'react'
import Icon from '@mui/icons-material/HowToRegOutlined'
import { SvgIconProps } from '@mui/material/SvgIcon'

const PersonsIcon = (props: SvgIconProps) => <Icon fontSize="small" {...props} />

export default PersonsIcon
export {}
